import * as React from "react";
import {
  Grid,
  Box,
  MenuItem,
  TextField,
  MenuList,
  Modal,
  makeStyles,
  Popper,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { MUISelect } from "../..";
import { tl } from "../../../../../utils";

import * as styles from "./styles.scss";
import * as flagStyles from "../styles.scss";

import { themeVariables } from "../../_Theme";
import { ICountryCode } from "../../../../../typings/ICountryCode";

export interface IProps {
  countryCodes: ICountryCode[];
  value: string;
  onChange: any;
  big?: boolean;
  onlyFlag?: boolean;
}

export const MUICountryCodesSelect = (props: IProps) => {
  const [value, setValue] = React.useState<string>(props.value);
  const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);

  const countryCodeValue = props.countryCodes.find(
    (item: ICountryCode) => item.name === value
  );

  React.useEffect(() => {
    props.onChange(value);
  }, []);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleClose = () => {
    setDialogOpen(false);
  };

  const classes = makeStyles({
    box: {
      height: "100%",
    },
    modal: {
      position: "absolute",
      top: "30%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: themeVariables.palette.common.white,
      width: "228px",
      padding: `${themeVariables.spacing * 2}px ${themeVariables.spacing *
        2}px ${themeVariables.spacing * 4}px`,
      borderBottom: themeVariables.border,
    },
  })({});

  const popperComponent = (props: any) => {
    return <Popper {...props} style={{ width: 260 }} keepMounted />;
  };

  return (
    <Box className={classes.box}>
      <Modal open={dialogOpen} onClose={handleClose} keepMounted>
        <Box className={classes.modal}>
          <Autocomplete
            onChange={(evt: any, value: any) => {
              if (value) {
                setValue(value.name);
                props.onChange(value.name);
                setDialogOpen(false);
              }
            }}
            open={dialogOpen}
            noOptionsText={tl("Совпадений не найдено")}
            popupIcon={null}
            closeIcon={null}
            filterOptions={(options: ICountryCode[], state: any) => {
              return options.filter(
                (option: ICountryCode) =>
                  option.country
                    .toLowerCase()
                    .includes(state.inputValue.toLowerCase()) ||
                  option.code.includes(state.inputValue)
              );
            }}
            renderInput={(params) => (
              <TextField
                variant="outlined"
                placeholder={tl("Код или название страны")}
                {...params}
              />
            )}
            PopperComponent={popperComponent}
            options={props.countryCodes}
            ListboxComponent={MenuList}
            renderOption={(option, { selected }) => (
              <MenuItem value={option.name} selected={selected}>
                <Grid container justifyContent="space-between">
                  <Grid item>
                    <Box className={styles.countrySelect}>
                      <Box
                        className={
                          props.big
                            ? `${
                                flagStyles.flag
                              } phoneInput-flag-${option.name || "unknown"}`
                            : `phone_country_flag ${option.name || "unknown"}`
                        }
                        pr={0.5}
                      />
                      <Box className={styles.countrySelectName}>
                        {tl(option.country || "")}
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box className={styles.countrySelectCode}>
                      {option.code}
                    </Box>
                  </Grid>
                </Grid>
              </MenuItem>
            )}
          />
        </Box>
      </Modal>
      <MUISelect
        fullWidth
        value={value}
        className={`${styles.iconLeft}`}
        onOpen={() => setDialogOpen(true)}
        open={false}
      >
        <MenuItem
          value={countryCodeValue.name}
          key={`code-${countryCodeValue.name}`}
        >
          <Grid
            container
            justifyContent="space-between"
            wrap="nowrap"
            alignItems="center"
          >
            <Grid item>
              <Box className={styles.countrySelect}>
                <Box
                  className={
                    props.big
                      ? `${
                          flagStyles.flag
                        } phoneInput-flag-${countryCodeValue.name || "unknown"}`
                      : `phone_country_flag ${countryCodeValue.name ||
                          "unknown"}`
                  }
                  pr={0.5}
                />
                {!props.onlyFlag &&
                  <Box className={styles.countrySelectName}>
                    {tl(countryCodeValue.country || "")}
                  </Box>
                }
              </Box>
            </Grid>
            {!props.onlyFlag &&
              <Grid item>
                <Box className={styles.countrySelectCode}>
                  {countryCodeValue.code}
                </Box>
              </Grid>
            }
          </Grid>
        </MenuItem>
      </MUISelect>
    </Box>
  );
};
